import Vue from "vue";

Vue.component("annex-notes", {
	props: ["level", "notes", "additionalClasses"],	
	data() {
		return {
			selected: null,
			loading: false			
		};
	},
	computed: {
		referenceStyle: function() {
			return `margin-left:${(this.level * 40)}px;`
		},
	},
	template: `
		<div :class="additionalClasses" v-if="notes != null && notes.length > 0">
			<div v-for="note in notes" :data-id="note.id" :id="'note_' + note.id" :key="note.id" class="row is-full" >
				<div class="columns mb-0">					
					<div v-if="note.referenceNumber != null"  class="column column-note-reference-number p-2" :style="referenceStyle">{{ note.referenceNumber }}</div>
					<i v-if="note.isReciprocityNote" class="fas fa-exclamation-triangle mt-4 has-text-warning"></i>
					<i v-if="note.excluded" class="fas fa-ban mt-4 has-text-danger" title="Exclude all or parts of this element from coverage"></i>
					<div class="column column-note-text p-2" :class="{'is-reciprocity': note.isReciprocityNote}" v-html="note.text"></div>
				</div>				
				<div v-if="note.items.length > 0" class="column" :style="referenceStyle">
					<note-items :note="note"></note-items>
				</div>
				<annex-notes v-if="note.children && note.children.length > 0" :level="level + 1" :notes="note.children"></annex-notes>
				<div v-if="note.footer" class="row is-full">
					<div class="columns mb-0">						
						<div class="column column-note-reference-number" :style="referenceStyle">&nbsp;</div>
						<div class="column column-note-text p-2" v-html="note.footer"></div>
					</div>
				</div>
			</div>			
		</div>
	`
});